<template>
    <div id="app">
        <!-- Fixed navbar -->
        <nav class="navbar navbar-expand-md navbar-dark fixed-top">
            <router-link :to="{ name: 'PCReDive' }" class="navbar-brand">
                <img width="50%" class="img-fluid" src="/static/images/logo.png" alt="蘭德索爾圖書館" />
                <h1 class="indexh1">蘭德索爾圖書館 超異域公主連結！ReDive WIKI</h1>
            </router-link>
            <button
                class="navbar-toggler"
                id="nav-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <div id="nav-icon3">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <ul class="navbar-nav ml-auto">
                    <router-link :to="{ name: 'Equipment' }" tag="li" class="p-1 p-lg-2">
                        <a class="" href="#">{{ $t("EquipmentMenu") }}</a>
                    </router-link>
                    <router-link :to="{ name: 'Character' }" tag="li" class="p-1 p-lg-2">
                        <a class="" href="#">{{ $t("CharacterMenu") }}</a>
                    </router-link>
                    <router-link :to="{ name: 'Map' }" tag="li" class="p-1 p-lg-2">
                        <a class="" href="#">{{ $t("MapDropMenu") }}</a>
                    </router-link>
                    <router-link :to="{ name: 'Armory' }" tag="li" class="p-1 p-lg-2">
                        <a class="" href="#">{{ $t("ArmoryMenu") }}</a>
                    </router-link>
                    <router-link :to="{ name: 'Gacha' }" tag="li" class="p-1 p-lg-2">
                        <a class="" href="#">{{ $t("GachaMenu") }}</a>
                    </router-link>
                    <router-link :to="{ name: 'Other' }" tag="li" class="p-1 p-lg-2">
                        <a class="" href="#">{{ $t("OtherMenu") }}</a>
                    </router-link>
                    <li class="p-1 p-lg-2">
                        <a href="#" data-toggle="modal" data-target="#Language">{{ $t("Language") }}</a>
                    </li>
                    <router-link :to="{ name: 'About' }" tag="li" class="p-1 p-lg-2">
                        <a class="" href="#">{{ $t("AboutMenu") }}</a>
                    </router-link>
                    <li class="p-1 p-lg-2">
                        <i id="moon" class="icon-custom moon pointer-curse" @click="moon()"></i>
                    </li>
                    <!-- <router-link :to="{ name: 'Login'}" tag="li" class="p-1 p-lg-2">
						<a class="" href="#">登入</a>
					</router-link> -->
                </ul>
            </div>
        </nav>
        <!-- Modal -->
        <div class="modal fade" id="Language" tabindex="-1" role="dialog" aria-labelledby="LanguageLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="LanguageLabel">{{ $t("Language") }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        目前只是測試版。<br />
                        只修改了部分介面的語系。<br />
                        <br />
                        This is beta test version.<br />
                        Only change part of user interface language, not data.<br />
                        <br />
                        <select class="custom-select form-control-sm" v-model="locale">
                            <option value="tw">繁體中文</option>
                            <option value="cn">简体中文</option>
                            <option value="en">English (US)</option>
                            <option value="jp">日本語</option>
                        </select>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="mobileShow" v-if="clientWidth < 1000">
            <ins
                :data-key="this.$route.path"
                class="adsbygoogle mobile-top-box"
                style="display:inline-block;"
                data-ad-client="ca-pub-8839550417970110"
                data-ad-slot="6399170169"
                data-ad-format="auto"
            ></ins>
        </div>
        <Loading
            :active.sync="this.$store.getters.getGlobalLoading.isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :background-color="'#4b4b4b'"
            :color="'#007bff'"
            :opacity="0.5"
            :is-full-page="fullPage"
        ></Loading>
        <div class="main">
            <div class="container mb-3" v-if="showAnnouncement == 'true'">
                <div class="item-box">
                    test
                    <button type="button" class="pcbtn float-right" @click="iKnow()">
                        知道了
                    </button>
                    <br />
                </div>
            </div>
            <router-view v-bind:clientWidth="clientWidth" />
        </div>
        <div class="a-fix" v-if="clientWidth >= 1800">
            <ins
                :data-key="this.$route.path"
                class="adsbygoogle mb-3"
                style="display:block"
                data-ad-client="ca-pub-8839550417970110"
                data-ad-slot="4286248387"
                data-ad-format="auto"
                data-full-width-responsive="true"
            ></ins>
        </div>
        <div class="a-fix-l" v-if="clientWidth >= 1800">
            <ins
                :data-key="this.$route.path"
                class="adsbygoogle"
                style="display:block"
                data-ad-client="ca-pub-8839550417970110"
                data-ad-slot="1325928180"
                data-ad-format="auto"
                data-full-width-responsive="true"
            ></ins>
        </div>
        <div id="return-to-top" @click="goTop" class="pointer-curse">
            Top
        </div>
        <footer class="footer mt-3">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-5">
                        <span class="text-muted"
                            >© 2018 蘭德索爾圖書館<br />
                            本站為粉絲自製與 Cygames , So-net Taiwan皆無任何關係
                        </span>
                    </div>
                    <div class="col-md-5 col-12 text-right d-none d-lg-block">
                        <span class="text-muted">
                            本網站使用的遊戲圖像的版權，<br />商標權和其他知識產權屬於原內容提供者(So-net Taiwan, Cygames)。
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
    name: "app",
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: "超異域公主連結☆Re:Dive (公主連結R) Wiki",
        // all titles will be injected into this template
        titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
    },
    components: {
        Loading,
    },
    data() {
        return {
            clientWidth: 0,
            showAnnouncement: false,
            locale: "tw",
            fullPage: true,
        };
    },
    watch: {
        locale(val) {
            this.$i18n.locale = val;
            localStorage.setItem("language", val);
        },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();

        var darkMode = localStorage.getItem("darkMode");
        if (darkMode == "true") {
            this.moon();
        }
        var language = localStorage.getItem("language");
		if (language) {			
            this.$i18n.locale = language;
            this.locale = language;
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        moon() {
            $("html").toggleClass("dark");
            if ($("html").hasClass("dark")) {
                localStorage.setItem("darkMode", "true");
            } else {
                localStorage.setItem("darkMode", "false");
            }
        },
        onCancel() {
            this.$store.dispatch("setGlobalLoading", { isLoading: false });
        },
        iKnow() {
            this.$cookie.set("isee", "false", 7);
            this.showAnnouncement = "false";
        },
        handleResize() {
            this.clientWidth = window.innerWidth;
        },
        goTop: function() {
            $("body,html").animate(
                {
                    scrollTop: 0, // Scroll to top of body
                },
                500
            );
        },
        konamiCode: function() {
            // a key map of allowed keys
            var allowedKeys = {
                37: "left",
                38: "up",
                39: "right",
                40: "down",
                65: "a",
                66: "b",
            };

            // the 'official' Konami Code sequence
            var konamiCode = ["up", "up", "down", "down", "left", "right", "left", "right", "b", "a"];

            // a variable to remember the 'position' the user has reached so far.
            var konamiCodePosition = 0;

            // add keydown event listener
            document.addEventListener("keydown", function(e) {
                // get the value of the key code from the key map
                var key = allowedKeys[e.keyCode];
                // get the value of the required key from the konami code
                var requiredKey = konamiCode[konamiCodePosition];

                // compare the key with the required key
                if (key == requiredKey) {
                    // move to the next key in the konami code sequence
                    konamiCodePosition++;

                    // if the last key is reached, activate cheats
                    if (konamiCodePosition == konamiCode.length) {
                        activateCheats();
                        konamiCodePosition = 0;
                    }
                } else {
                    konamiCodePosition = 0;
                }
            });

            function activateCheats() {
                $("body").css("background", "url('/static/images/Mappu.gif') repeat");
                var audio = new Audio("/static/images/kururinpo.mp3");
                audio.loop = true;
                audio.play();
                //$("body").addClass("bg41");
            }
        },
    },
    mounted: function() {
        (adsbygoogle = window.adsbygoogle || []).push({});
        this.$nextTick(function() {
            setTimeout(function() {
                var alt = $("body > div> a > img");
                alt.remove();
            }, 2000);
        });

        $(document).on("click", "#nav-toggler", function() {
            $("#nav-icon3").toggleClass("open");
        });

        $(document).on("click", ".navbar-brand", function() {
            $("#nav-icon3").removeClass("open");
            $(".navbar-collapse").collapse("hide");
        });

        $(".navbar-nav>li>a").on("click", function() {
            $(".navbar-collapse").collapse("hide");
            $("#nav-icon3").toggleClass("open");
        });

        //var showAnnouncement = this.$cookie.get('isee')
        //this.showAnnouncement = showAnnouncement;

        $(window).scroll(function() {
            if ($(this).scrollTop() >= 50) {
                // If page is scrolled more than 50px
                $("#return-to-top").fadeIn(200); // Fade in the arrow
            } else {
                $("#return-to-top").fadeOut(200); // Else fade out the arrow
            }
        });

        this.konamiCode();
    },
};
</script>
<style rel="stylesheet/sass" lang="sass">
.bg41
	background: url("/static/images/bg41.jpg") no-repeat
	background-attachment: fixed
	-webkit-transition: background 20s ease-in
	-moz-transition: background 20s ease-in
	-o-transition: background 20s ease-in
	transition: background 20s ease-in
	.item-box
		background: transparent
</style>
